import { MathUtils } from '../../thirdparty/three/imports';

export class MathUtils3D
{
    static randFloatSpread(range: number)
    {
        return MathUtils.randFloatSpread(range);
    }

    static degToRad(degrees: number)
    {
        return MathUtils.degToRad(degrees);
    }

    static clamp(value: number, min: number, max: number)
    {
        return MathUtils.clamp(value, min, max);
    }

    static randFloat(low: number, high: number)
    {
        return MathUtils.randFloat(low, high);
    }
}
